import Logout from './components/Logout';

import Home from './components/Content/Home/Home';

import Metadata from './components/Content/Metadata/Main';
import MetadataAdd from './components/Content/Metadata/Add';
import MetadataPreview from './components/Content/Metadata/Preview';

import Keywords from './components/Content/Keywords/Main';


import {Switch, Route } from "react-router-dom";

export default function MenuRouting() {
    return (
        <Switch>
            <Route exact path="/">
                <Home />
            </Route>
            <Route path="/Metadata/add">
                <MetadataAdd />
            </Route>
            <Route path="/metadata/preview/:dataId">
                <MetadataPreview />
            </Route>
            <Route path="/Metadata">
                <Metadata />
            </Route>
           
            <Route path="/keywords">
                <Keywords />
            </Route>
            <Route path="/logout">
                <Logout />
            </Route>
        </Switch>
    )
}